import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "../../../environments/environment";

export abstract class DmsHttp {
    private ENTORNO = environment.ENTORNO;

    constructor(private http: HttpClient, private urlModulo: string) { }

    post<Y>(endpoint: string, body?, headers?: HttpHeaders): Observable<Y> {
        return this.http
            .post<Y>(
                this.ENTORNO +
                (this.urlModulo !== null ? this.urlModulo : "") +
                endpoint,
                body,
                { headers: headers }
            )
            .pipe(
                map((data: any) => {
                    return this.filterData(data);
                })
            );
    }

    newPost<Y>(newurl: string, body?, headers?: HttpHeaders): Observable<Y> {
        return this.http
            .post<Y>(this.ENTORNO + newurl, body, { headers: headers })
            .pipe(
                map((data: any) => {
                    return this.filterData(data);
                })
            );
    }

    filterData(data: any): any {
        if (data) {
            if (data.contents || data.contents === null) {
                return data.contents;
            } else if (data.Content || data.Content === null) {
                return data.Content;
            } else if (data.Response || data.Response === null) {
                return data.Response;
            } else {
                return data;
            }
        }
        return "No llega objeto de respuesta";
    }
}
